import React, { Component } from "react";
import { Autocomplete, FormHelperText, FormLabel, OutlinedInput, TextField } from "@mui/material";

import commonUtilities from "utilities/common";
import { withLocalizer } from "utilities/withLocalizer";
import getRoomTypes from "services/roomType/roomType.service";
import { connect } from "react-redux";
import { CONFIGURATION } from "utilities/configuration";
import InputAdornment from "@mui/material/InputAdornment";
import ClearIcon from "@mui/icons-material/Clear";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

class DeviationHotel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            deviationRooms: [],
            deviationCabins: []
        };
    }

    handleData = (event, hotel) => {
        let { data, title, index, events, deviationProductType, deviationTypes, deviationIndex, handleStep2DeviationData, deviationCruises } = this.props;
        const { quote, deviationOptionIndex } = data || {};
        const deviationDepartureDate = quote?.deviationTypes?.[deviationOptionIndex]?.departureDate;

        let product = {};

        product.code = (hotel) ? hotel.code : "";
        product.hotelRefCode = (hotel) ? hotel.hotelRefCode : "";
        product.name = (hotel) ? hotel.name : "";
        product.url = (hotel) ? hotel.url : "";
        product.city = (hotel) ? hotel.city : "";
        product.country = (hotel) ? hotel.country : "";
        product.location = (hotel) ? hotel.location : "";
        product.roomTypes = [];
        product.productType = title;

        let deviationTypesClone = structuredClone(deviationTypes);

        deviationTypesClone[deviationOptionIndex].deviation[deviationIndex].products[index] = product;

        handleStep2DeviationData(deviationTypesClone);

        if(hotel) {
            if (deviationProductType !== "Cruise") {
                this.props
                    .dispatch(
                        getRoomTypes(deviationTypes[deviationOptionIndex]?.deviation[deviationIndex].destination.providerCode, deviationDepartureDate, product.code)
                    )
                    .then((response) => {

                        let rooms = response?.payload?.data;
                        rooms = [...rooms, {
                            code: CONFIGURATION.CUSTOM_ROOM_TYPE_CODE,
                            name: this.props.localize("qma-custom-room-type"),
                            url: ""
                        }];

                        this.setState({ deviationRooms: rooms });
                    });
            } else {
                this.setState({ deviationRooms: hotel?.cabins });
            }
        }
    };

    handleRoomData = (event, isCustomRoomNameHandler, roomType) => {
        let { index, deviationProductType, deviationTypes, deviationIndex, handleStep2DeviationData, deviationCruises, data } = this.props;
        const { deviationOptionIndex } = data || {};

        let deviationTypesClone = structuredClone(deviationTypes);

        let product = deviationTypesClone[deviationOptionIndex].deviation[deviationIndex].products[index].roomTypes[0] ?? {};

        if(roomType) {
            product.code = (roomType) ? roomType.code : "";
            product.name = (roomType) ? roomType.name : "";
            product.url = (roomType) ? roomType.url : "";
            product.roomType = this.props.roomType;
        }
        else {
            if(isCustomRoomNameHandler && product.code === CONFIGURATION.CUSTOM_ROOM_TYPE_CODE) {
                product.customName = event.target.value;
            }
            else {
                product.code = "";
                product.name = "";
                product.url = "";
            }
        }

        deviationTypesClone[deviationOptionIndex].deviation[deviationIndex].products[index].roomTypes[0] = product;

        handleStep2DeviationData(deviationTypesClone);
    };

    handleCustomNameClear = () => {
        let { index, deviationTypes, deviationIndex, handleStep2DeviationData, data } = this.props;
        const { deviationOptionIndex } = data || {};

        let deviationTypesClone = structuredClone(deviationTypes);

        let product = deviationTypesClone[deviationOptionIndex].deviation[deviationIndex].products[index].roomTypes[0] ?? {};

        product.customName = "";

        deviationTypesClone[deviationOptionIndex].deviation[deviationIndex].products[index].roomTypes[0] = product;

        handleStep2DeviationData(deviationTypesClone);
    };

    filterDeviationRooms(deviationDetails){
        let deviations = deviationDetails?.deviation;
        if(deviations?.length > 0 ){
            let rooms = [];
            deviations?.map((deviation) => {
                deviation.products?.map(product => {
                    product?.roomTypes?.map(room => {
                        rooms.push(product?.code + "-" + room?.code);
                    });
                });
            });
            return rooms;
        } else {
            return [];
        }
    }

    // it is used to refine the index for clone
    getIndex(isClone, index, roomType,selectedDeviation ) {

        // remove null or undefined items from beginning for clone.
        let products = selectedDeviation?.products;

        if(isClone && products) {
            while (products.length > 0 && (products[0] === null || products[0] === undefined)) {
                products.shift(); // Remove the first element
            }
        }

        let selectedHotelCount = products?.filter(s => s?.productType === "Hotel")?.length??0;
        let selectedCruiseCount = products?.filter(s => s?.productType === "Cruise")?.length??0;

        if(isClone) {
            let i = index % 2;
            if(roomType?.toLowerCase() === "room") {
                return (i < selectedHotelCount) ? i : -1;
            }
            else {
                return (i < selectedCruiseCount) ? i + selectedHotelCount : -1;
            }
        }
        return index;
    }

    componentDidMount() {
        let { data, index, deviationProductType, deviationTypes, deviationIndex, deviationCruises, roomType } = this.props;
        const { isClone, quote, deviationOptionIndex } = data || {};
        const deviationDepartureDate = quote?.deviationTypes?.[deviationOptionIndex]?.departureDate;

        let selectedDeviation = deviationTypes[deviationOptionIndex]?.deviation[deviationIndex];

        const realIndex = this.getIndex(isClone, index, roomType, selectedDeviation);

        if(deviationDepartureDate) {
            if (deviationProductType !== "Cruise") {
                this.props
                    .dispatch(
                        getRoomTypes(deviationTypes[deviationOptionIndex]?.deviation[deviationIndex].destination.providerCode, deviationDepartureDate, deviationTypes[deviationOptionIndex]?.deviation[deviationIndex]?.products[realIndex]?.code)
                    )
                    .then((response) => {
                        
                        let rooms = response?.payload?.data;
                        
                        let productCode = selectedDeviation.products[realIndex]?.code;
                        if(productCode) {
                            rooms = [...rooms, {
                                code: CONFIGURATION.CUSTOM_ROOM_TYPE_CODE,
                                name: this.props.localize("qma-custom-room-type"),
                                url: ""
                            }];
                        }
                        this.setState({ deviationRooms: rooms });
                    });
            } 
        }
    }

    render() {
        let { data, events, index, errors, error, title, deviationHotels, deviationCruises, deviationProductType, deviationTypes, deviationIndex, roomType } = this.props;
        let { isClone, masterHotels, quote, optionIndex, deviationOptionIndex } = data;
        let { productTypes } = quote;
        let productType = productTypes[optionIndex];
        let { products } = productType;
        let product = products[index];
        let { roomTypes } = product;
        let indexText = commonUtilities.getNumberPostFixText(index);
        let selectPlaceHolder = this.props.localize("qma-select-label");
        let hotelPlaceHolder = this.props.localize((productType?.productType?.code.toLowerCase() === "cruise") ? "qma-cruise" : "qma-hotel");
        let choicePlaceHolder = this.props.localize("qma-choice");
        let selectedRooms = this.filterDeviationRooms(deviationTypes[deviationOptionIndex]);
        let selectedDeviation = deviationTypes[deviationOptionIndex]?.deviation[deviationIndex];

        const realIndex = this.getIndex(isClone, index, roomType, selectedDeviation);

        let cabins = [];
        if(roomType.toLowerCase() === "cabin") {
            let productCode = selectedDeviation.products[realIndex]?.code;
            cabins = deviationCruises.find(cruise => cruise.code === productCode)?.cabins ?? [];
            
            if(productCode) {
                cabins = [...cabins, {
                    code: CONFIGURATION.CUSTOM_ROOM_TYPE_CODE,
                    name: this.props.localize("qma-custom-room-type"),
                    url: ""
                }];
            }
        }
        
        let selectedRoomType = selectedDeviation?.products[realIndex]?.roomTypes?.[0];
        let customRoomTypeError = (selectedRoomType?.code === CONFIGURATION.CUSTOM_ROOM_TYPE_CODE) ? errors?.deviationError?.customRoomTypes?.[realIndex] : null;
        let roomError = errors?.deviationError?.hotel || errors?.deviationError?.rooms?.[realIndex];

        return (
            <div className="row hotel-wrapper">
                <div className="row" data-testid="hotel-label">
                    <div className="row form-control-wrapper">
                        <FormLabel>
                            {title + " - " + (index + 1) + indexText + " " + choicePlaceHolder}
                        </FormLabel>
                        <Autocomplete
                            autoHighlight
                            popupIcon={CONFIGURATION.APPLY_FIELD_ADORNMENT ? <ExpandMoreIcon/> : null}
                            data-testid="autocomplete-id"
                            value={selectedDeviation?.products[realIndex] || ""}
                            isOptionEqualToValue={(option) =>
                                option.name === product?.name
                            }
                            onChange={(event, product) => this.handleData(event, product)}
                            options={deviationProductType === "Cruise" ? deviationCruises: deviationHotels}
                            getOptionLabel={(product) => (product ? title?.toLowerCase() === "cruise" ? `${product.name} \\ ${product?.location}`: product.name : "")}
                            renderOption={(props, hotel, index) => (
                                <li {...props} keys={index}>
                                    {title?.toLowerCase() === "cruise" ? `${hotel.name} \\ ${hotel?.location}`: hotel.name}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    placeholder={selectPlaceHolder}
                                    // className="formControl"
                                    className={(!error) ? "formControl" : "errorControl formControl"}

                                    {...params}
                                />
                            )}
                        />
                    </div>
                    {errors?.deviationError?.hotel ? (
                        <FormHelperText error={errors?.deviationError?.hotel}>
                            {errors?.deviationError?.hotel?.trim().length > 0 && errors?.deviationError?.hotel}
                        </FormHelperText>
                    ) : null}
                </div>

                <div
                    className={
                        "show row margin-top"
                    }
                >
                    <div className="row room-category-wrapper">
                        <div className="row form-control-wrapper">
                            <FormLabel>
                                {`Select ${roomType.toLowerCase()} type`}
                            </FormLabel>
                            <Autocomplete
                                autoHighlight
                                popupIcon={CONFIGURATION.APPLY_FIELD_ADORNMENT ? <ExpandMoreIcon/> : null}
                                value={selectedDeviation?.products[realIndex]?.roomTypes?.[0] ?? ""}
                                isOptionEqualToValue={(option) =>
                                    option.name === roomType?.name
                                }
                                onChange={(event, roomType) => this.handleRoomData(event, false, roomType)}
                                getOptionLabel={(roomType) => (roomType ? roomType.name : "")}
                                // TODO:: Move this logic outside 
                                options={roomType.toLowerCase() !== "cabin" ? this.state?.deviationRooms && this.state?.deviationRooms?.length > 0 ? 
                                    this.state?.deviationRooms?.filter(
                                        (room) =>
                                            !selectedRooms?.map((selectedRoom) => selectedRoom).includes(selectedDeviation.products[realIndex]?.code + "-" + room?.code)
                                    ) : this.state?.deviationRooms :  cabins}
                                renderOption={(props, roomCategory, index) => (
                                    <li {...props} keys={index}>
                                        {roomCategory.name}
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        placeholder={selectPlaceHolder}
                                        className={(!error) ? "formControl" : "errorControl formControl"}

                                        {...params}
                                    />
                                )}
                            />
                        </div>
                        {roomError ? (
                            <FormHelperText error={roomError?.trim().length > 0}>
                                {roomError}
                            </FormHelperText>
                        ) : null}
                    </div>
                    {selectedRoomType?.code === CONFIGURATION.CUSTOM_ROOM_TYPE_CODE ? 
                        <div className="row row-height margin-top-1x">
                            <div className="row form-control-wrapper">
                                <FormLabel>
                                    {`Select ${this.props.localize("qma-custom-room-type")} ${roomType.toLowerCase()} name`}
                                </FormLabel>
                                <OutlinedInput
                                    fullWidth
                                    inputProps={{ maxLength: 255 }}
                                    name="customRoomType"
                                    id="outlined-group-name"
                                    value={selectedRoomType.customName || ""}
                                    onChange={(event) => {
                                        this.handleRoomData(event, true);
                                    }
                                    }
                                    aria-describedby="outlined-custom-room-type-helper-text"
                                    error={customRoomTypeError?.trim().length > 0}
                                    endAdornment={
                                        CONFIGURATION.APPLY_FIELD_ADORNMENT ? <InputAdornment position="end">
                                            { (selectedRoomType.customName && selectedRoomType.customName.length > 0 ? <ClearIcon className="clear-icon" onClick={this.handleCustomNameClear} edge="end"/> : null) }
                                        </InputAdornment> : null
                                    }
                                />
                            </div>
                            <FormHelperText error={customRoomTypeError?.trim().length > 0}>
                                {customRoomTypeError?.trim().length > 0 && (
                                    customRoomTypeError
                                )}
                            </FormHelperText>
                        </div> : null
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    citiesMasterData: state.citiesMasterData,
    cruiseData: state.cruise
});

export default connect(mapStateToProps)(withLocalizer(DeviationHotel));

